import Error from 'custom-error';

//
var script = {
  name: "CustomRadio",
  meta: {
    description: "Componente común CustomRadio personalizado y CustomRadioButton, sólido.",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  components: {
    Error
  },

  data() {
    return {
      isDisabledOption: this.disabled
    };
  },

  props: {
    isQuestionList: {
      type: [Boolean],
      default: false,
      meta: {
        description: "Parámetro de entrada del CustomRadio"
      }
    },
    value: {
      type: [String, Boolean],
      default: "",
      meta: {
        description: "Parámetro de entrada del CustomRadio",
        example: ""
      }
    },
    options: {
      type: [Array, Object],
      default: () => [],
      meta: {
        description: "Posibilita elegir entre varios artículos",
        example: '"[4, 8, 15, 16, 23, 42]'
      }
    },
    label: {
      type: String,
      default: "",
      meta: {
        description: "Control para mostrar texto",
        example: "Texto requerido"
      }
    },
    name: {
      type: String,
      default: "",
      meta: {
        description: "Estable el nombre del radio",
        example: "Texto requerido"
      }
    },
    error: {
      type: Boolean,
      default: false,
      meta: {
        description: "Estado Error",
        example: "Texto requerido"
      }
    },
    customErrorMsg: {
      type: String,
      default: function () {
        return this.error;
      },
      meta: {
        description: "Mensaje de error encontrado",
        example: "Texto requerido"
      }
    },
    isInline: {
      type: Boolean,
      default: false,
      meta: {
        description: "Establece que está en línea",
        example: "true"
      }
    },
    isDisabled: {
      type: Boolean,
      default: false,
      meta: {
        description: "Estado disabled",
        example: "true"
      }
    },
    containerClass: {
      type: String,
      default: ""
    },
    computed: {
      isValid() {
        return !this.error && this.dirty;
      }

    },
    id: {
      type: String,
      default: "rbtnRadioButton",
      meta: {
        description: "Id del Componente CustomRadioButton",
        example: "IdCustomRadioButton"
      }
    },
    changeEvent: {
      type: Function,
      default: () => {},
      meta: {
        description: 'Evento que se dispara al seleccionar una opción',
        example: ''
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateValue(value) {
      if (value === "true") {
        this.$emit("input", true);
      } else if (value === "false") {
        this.$emit("input", false);
      } else {
        this.$emit("input", value);
      }
    },

    async Change(item) {
      this.options;
      let self = this;

      if (this.isDisabledOption) {
        return;
      }

      await self.options.map(val => {
        if (val.label == item.label) {
          val.check = true;
        } else {
          val.check = false;
        }
      });
      self.invalid = !self.options.some(elem => elem.check == true);
      self.changeEvent(item);
    }

  },
  watch: {
    disabled: function () {
      this.isDisabledOption = this.disabled;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [!_vm.isQuestionList && _vm.options.length > 0 ? _c('div', [_c('div', {
    staticClass: "col-12"
  }, [_vm.label ? _c('label', {
    staticClass: "data-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    class: _vm.containerClass
  }, [_vm._l(_vm.options, function (option, index) {
    return _c('div', {
      key: index,
      staticClass: "custom-control custom-radio",
      class: {
        'custom-control-inline': _vm.isInline
      }
    }, [_c('input', {
      staticClass: "custom-control-input",
      class: {
        invalid: _vm.error
      },
      attrs: {
        "disabled": _vm.isDisabled,
        "type": "radio",
        "name": _vm.name,
        "id": _vm.name + option.value
      },
      domProps: {
        "checked": _vm.value === option.value,
        "value": option.value
      },
      on: {
        "input": function ($event) {
          return _vm.updateValue($event.target.value);
        },
        "click": function ($event) {
          return _vm.Change(option);
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "custom-control-label",
      class: {
        invalid: _vm.error
      },
      attrs: {
        "for": _vm.name + option.value
      }
    }, [_vm._v(_vm._s(option.label))])]);
  }), _vm._v(" "), _vm.option !== undefined && _vm.error ? _c('error', {
    attrs: {
      "variant": "no-border",
      "message": _vm.customErrorMsg
    }
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm.isQuestionList && _vm.options !== undefined && _vm.options.length > 0 ? _c('div', {
    staticClass: "align-items-end d-flex p-0 custom-radio-container"
  }, _vm._l(_vm.options, function (item, indx) {
    return _c('div', {
      key: indx,
      on: {
        "click": function ($event) {
          return _vm.Change(item);
        }
      }
    }, [_c('div', {
      staticClass: "text-center pointer rounded-top mb-0 custom-radio-button full-div",
      class: item.invalid == true ? 'bg-error' : item.check == true ? 'bg-green' : 'bg-gray'
    }, [_c('div', {
      staticClass: "radio"
    }, [_c('label', {
      staticClass: "w-100 mb-0"
    }, [_c('input', {
      attrs: {
        "id": _vm.id + "-" + indx,
        "name": item.name + '-' + indx,
        "type": "radio",
        "disabled": _vm.isDisabledOption || item.disabled
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr rounded-circle pointer"
    }, [!item.icon ? _c('i', {
      staticClass: "cr-icon text-white",
      class: item.check == true ? 'fa fa-check check-opacity' : ''
    }) : _vm._e()])])]), _vm._v(" "), item.icon ? _c('i', {
      class: item.icon,
      style: {
        color: item.check == true ? 'white' : item.iconColor ? item.iconColor : '#ff7058'
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "step-label"
    }, [_vm._v(_vm._s(item.label))])]), _vm._v(" "), _c('div', {
      staticClass: "text-center pointer rounded-top mb-0 custom-radio-button-mobile mobile-div",
      class: item.invalid == true ? 'bg-error' : item.check == true ? 'bg-green' : 'bg-gray'
    }, [_c('div', {
      staticClass: "radio"
    }, [_c('label', {
      staticClass: "w-100 mb-0"
    }, [_c('input', {
      attrs: {
        "id": _vm.id + "-" + indx,
        "name": _vm.name + '-' + indx,
        "type": "radio",
        "disabled": _vm.isDisabledOption || item.disabled
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr rounded-circle pointer"
    })])]), _vm._v(" "), _c('span', {
      staticClass: "step-label-mobile"
    }, [_vm._v(_vm._s(item.label))])])]);
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm.error ? _c('error', {
    staticClass: "mt-1 ",
    attrs: {
      "variant": "no-border",
      "message": _vm.customErrorMsg
    }
  }) : _vm._e()], 1)]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-74d392f2_0", {
    source: "p.text-left.d-inline[data-v-74d392f2]{font-size:110px!important}.custom-control-input[data-v-74d392f2],.custom-control-label[data-v-74d392f2]{cursor:pointer}.custom-control-input:checked.custom-control-input:checked:disabled~.custom-control-label[data-v-74d392f2]::before{color:#fff;border-color:#2db782;background-color:#2db782}.custom-control-input.invalid~.custom-control-label[data-v-74d392f2]::before{background-color:#f7d7da;border-color:#e85c5c}.sucess-icon[data-v-74d392f2]{font-size:19px;position:absolute;top:9px;right:7px;color:#3f5b60;margin-right:.2rem}.sucess-icon[data-v-74d392f2]:before{content:\"\\f058\";color:#2db782}div.invalid[data-v-74d392f2]:not(input){color:#e85c5c}.form-control-icon-normal[data-v-74d392f2]{position:absolute;top:9px;right:10px;color:#3f5b60;margin-right:.2rem}.icon-invalid[data-v-74d392f2]{color:#e85c5c}.custom-error i[data-v-74d392f2]{float:left;margin-top:15px;margin-right:10px;color:#e85c5c}.custom-control-label.invalid[data-v-74d392f2]::before{border-color:#e85c5c;border-width:2px;background:#f7d7da}@media (max-width:375px){.full-div[data-v-74d392f2]{display:none!important}.custom-radio-button-mobile.mobile-div[data-v-74d392f2]{display:block!important}}.mobile-div[data-v-74d392f2]{display:none!important}.bg-error[data-v-74d392f2]{background:#ffebeb 0 0 no-repeat padding-box!important;border:1px solid #c9545e!important;border-radius:5px 5px 0 0;opacity:1}.bg-error .rounded-circle[data-v-74d392f2]{border:2px solid #c9545e!important;opacity:1}.bg-error .step-label[data-v-74d392f2]{text-align:center;font:Regular 11px/13px Lato;letter-spacing:0;color:#c9545e;opacity:1}.bg-error .step-label-mobile[data-v-74d392f2]{text-align:center;font:Regular 8px/8px Lato;letter-spacing:0;color:#c9545e;opacity:1}.pointer[data-v-74d392f2]{cursor:pointer}.question[data-v-74d392f2]{box-shadow:-3px 1px 3px #00000029;align-content:space-between}.bg-gray[data-v-74d392f2]{background:#f2f2f2}.bg-green[data-v-74d392f2]{background:#2db782}.radio label[data-v-74d392f2]:after{content:\"\";display:table;clear:both}.radio .cr[data-v-74d392f2]{position:relative;display:inline-block;border:2px solid #a9a9a9;border-radius:.25em;width:1.2em;height:1.2em;margin-top:4px}.cr[data-v-74d392f2]{border-radius:50%}.radio .cr .cr-icon[data-v-74d392f2]{position:absolute;font-size:.7em;line-height:0;top:53%;left:13%}.cr-icon[data-v-74d392f2]{margin-top:.04em}.radio label input[type=radio][data-v-74d392f2]{display:none}.radio label input[type=radio]+.cr>.cr-icon[data-v-74d392f2]{opacity:0}.radio label input[type=radio]:checked+.cr>.cr-icon[data-v-74d392f2]{opacity:1}.radio label input[type=radio]:disabled+.cr[data-v-74d392f2]{opacity:.5}.rounded-top[data-v-74d392f2]{height:100%;display:flex;flex-direction:column;justify-content:center}label[data-v-74d392f2],p[data-v-74d392f2]{font-weight:400}.step-label[data-v-74d392f2]{display:block;font:Regular 11px/11px Lato;font-size:15px;letter-spacing:0;color:#c9c9c9;font-weight:100}.step-label-mobile[data-v-74d392f2]{display:block;font:Regular 8px/8px Lato;font-size:8px;letter-spacing:0;color:#c9c9c9;font-weight:100}.bg-green .step-label[data-v-74d392f2],.bg-green .step-label-mobile[data-v-74d392f2]{color:#fff}.bg-green .radio .w-100 .cr.rounded-circle[data-v-74d392f2]{border:2px solid #fff;opacity:1}.step-label.active[data-v-74d392f2]{color:#2db782;font-weight:700}.error-val[data-v-74d392f2]{color:#ff5b5c;display:block;padding-left:25px}.success-val[data-v-74d392f2]{color:#2db782;display:block}.warning-val[data-v-74d392f2]{color:#af6708;display:block}.question-number-sup[data-v-74d392f2]{font:21px Lato;letter-spacing:0;color:#fff}.custom-control-label.font[data-v-74d392f2]{font:400 16px/19px Lato;color:#11291b;padding-top:4px}.custom-radio-container .custom-radio-button[data-v-74d392f2]{width:70px;margin-right:8px}.custom-radio-container .custom-radio-button-mobile[data-v-74d392f2]{width:30px;margin-right:3px}.check-opacity[data-v-74d392f2]{opacity:1!important}",
    map: undefined,
    media: undefined
  }), inject("data-v-74d392f2_1", {
    source: ".ordered-header-card-custom-radio>.custom-radio-container>div[data-v-74d392f2]{margin-right:3px;border:1px solid #d3d3d3;border-bottom:0;border-radius:5px 5px 0 0!important}.ordered-header-card-custom-radio>.custom-radio-container>div[data-v-74d392f2]:last-child{margin-right:0}.ordered-header-card-custom-radio>.custom-radio-container .custom-radio-button[data-v-74d392f2],.ordered-header-card-custom-radio>.custom-radio-container .custom-radio-button-mobile[data-v-74d392f2]{margin-right:0!important}.ordered-header-card-custom-radio>.custom-radio-container .custom-radio-button-mobile.bg-gray[data-v-74d392f2],.ordered-header-card-custom-radio>.custom-radio-container .custom-radio-button.bg-gray[data-v-74d392f2]{background-color:transparent!important}.ordered-header-card-custom-radio>.custom-radio-container .custom-radio-button[data-v-74d392f2]{width:100%}.ordered-header-card-custom-radio>.custom-radio-container .custom-radio-button .radio[data-v-74d392f2],.ordered-header-card-custom-radio>.custom-radio-container .custom-radio-button .step-label[data-v-74d392f2]{padding-left:1rem;padding-right:1rem}.radio-icon[data-v-74d392f2]{height:100%}.radio-icon>div.custom-radio-container[data-v-74d392f2]{align-items:normal!important;height:100%}@media (max-width:991px){.radio-icon>div.custom-radio-container[data-v-74d392f2]{display:block!important;height:auto}.radio-icon>div.custom-radio-container>div[data-v-74d392f2]{margin-top:10px}}.radio-icon>div.custom-radio-container>div[data-v-74d392f2]{flex:1}@media (min-width:991px){.radio-icon>div.custom-radio-container>div[data-v-74d392f2]:not(:last-child){padding-right:3px}}@media (max-width:375px){.radio-icon>div.custom-radio-container>div>div.custom-radio-button-mobile[data-v-74d392f2]{display:none!important}}.radio-icon>div.custom-radio-container>div>div.custom-radio-button[data-v-74d392f2]{flex-direction:row!important;align-items:center;width:100%;border-radius:0!important;border:1px solid #d2d2d2;padding:10px}@media (max-width:375px){.radio-icon>div.custom-radio-container>div>div.custom-radio-button[data-v-74d392f2]{display:flex!important}}@media (max-width:991px){.radio-icon>div.custom-radio-container>div>div.custom-radio-button[data-v-74d392f2]{justify-content:flex-start;padding-left:22vw}}.radio-icon>div.custom-radio-container>div>div.custom-radio-button.bg-green .radio .w-100 .cr.rounded-circle[data-v-74d392f2]{border:5px solid #fff}.radio-icon>div.custom-radio-container>div>div.custom-radio-button.bg-green[data-v-74d392f2]{border:0}.radio-icon>div.custom-radio-container>div>div.custom-radio-button.bg-green>.step-label[data-v-74d392f2]{color:#fff!important}.radio-icon>div.custom-radio-container>div>div.custom-radio-button.bg-error .radio .w-100 .cr.rounded-circle[data-v-74d392f2]{border:1px solid #a9a9a9!important;background-color:#fff!important}.radio-icon>div.custom-radio-container>div>div.custom-radio-button.bg-gray[data-v-74d392f2]{background-color:transparent!important}.radio-icon>div.custom-radio-container>div>div.custom-radio-button>.step-label[data-v-74d392f2]{color:#11291b;text-align:left}.radio-icon>div.custom-radio-container>div>div.custom-radio-button[data-v-74d392f2]>:not(:last-child){margin-right:8px}.radio-icon>div.error[data-v-74d392f2]{height:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-74d392f2";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installCustomRadio(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('CustomRadio', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
